import React from 'react'
import classes from './LinkAccordionItem.module.css'
import {
    AccordionItem, AccordionButton, AccordionPanel, Flex
} from '@chakra-ui/react'

const btnExpandedProps = {
    bg: 'orange',
    _hover: {
        bg: 'var(--orange-btn-hover-background)'
    }
}

const btnHoverProps = {
    bg: 'orange'
}

function LinkAccordionItem({children, ...props}) {
    return (
        <AccordionItem className={classes.container}>
            <AccordionButton
                className={classes.btn}
                fontSize='lg'
                _expanded={btnExpandedProps}
                _hover={btnHoverProps}
            >
                {props.title}
            </AccordionButton>
            <AccordionPanel>
                <Flex direction='column' className={classes.links}>
                    {children}
                </Flex>
            </AccordionPanel>
        </AccordionItem>
    )
}

export default LinkAccordionItem
